import { Image, H4, H6, P, UL, LI } from '../../../../AbstractElements';
import { JohanDeo, JohanDeoMailId, ProjectDescription, ProjectDescriptionDetails } from '../../../../Constant';
import { Col, Media, Row } from 'reactstrap';
import React, { Fragment, useState, useEffect} from 'react';
import user1 from '../../../../assets/images/user/1.jpg';
import { AppointmentPaymentList } from '../../../../apiController';

const InvoiceDetails = ({filterData, rowData, data}) => {

  const balance = rowData.payment.map(t=> t.discount_amt) - rowData.payment.map(t=> t.discount_amt)
  return (
    <Fragment>
      <Row className='invo-profile'>
        <Col xl='7' xs='5'>
        </Col>
        <Col xl='5' xs='7'>
          <div className='text-md-end'>
            <div id='project'>
              {/* <H6>{"Witte Hospital"}</H6> */}
              <div className='order-box'>
            <UL attrUL={{ className: 'simple-list sub-total total' }}>
              <LI attrLI={{ className: 'border-0 bg-transparent ' }}>
                Total <span className='count'>&#x20B9; {rowData.payment.map(t=> t.total)} <br />
                </span>
              </LI>
            </UL>
            <UL attrUL={{ className: 'simple-list sub-total total' }}>
              <LI attrLI={{ className: 'border-0 bg-transparent ' }}>
                Due Amount <span className='count'>&#x20B9; {balance}</span>
              </LI>
            </UL>
            <UL attrUL={{ className: 'simple-list sub-total total' }}>
              <LI attrLI={{ className: 'border-0 bg-transparent ' }}>
              Paid Amount <span className='count'>&#x20B9; {rowData.payment.map(t=> t.already_paid_amount)}</span>
              </LI>
            </UL>
            <UL attrUL={{ className: 'simple-list sub-total total' }}>
              <LI attrLI={{ className: 'border-0 bg-transparent ' }}>
              Last transaction <span className='count'>&#x20B9; {rowData.payment.map(t=> t.paid_amt)}</span>
              </LI>
            </UL>
            </div>
            </div>
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};
export default InvoiceDetails;
